import { commonConstants } from "@/actions/constants/commonConstants";
import { cookieConstants } from "@/actions/constants/cookieConstants";
import { cookiesService } from "@/services/cookiesService";
import { call, put } from "redux-saga/effects";

function * createCookiesSaga(action:any):any{
    try {
        const response = yield call(cookiesService.createCookieService,action.payload);
        if(response.success){
            yield put({type:cookieConstants.createCookieSuccess,payload:response.resultObject})
        }else{
            yield put({type:cookieConstants.createCookieFailure,payload:response.errorMessage})
            yield put({type:commonConstants.showErrorMessage,payload:response.errorMessage})
        }
    } catch (error) {
        yield put({type:cookieConstants.createCookieFailure,payload:error.Message})
        yield put({type:commonConstants.showErrorMessage,message:error.message})
    }
}
function * getCookiesSaga(action:any):any{
    try {
        const response = yield call(cookiesService.getCookieService,action.payload);
        if(response.success){
            yield put({type:cookieConstants.getCookieSuccess,payload:response.resultObject})
        }else{
            yield put({type:cookieConstants.getCookieFailure,payload:response.errorMessage})
            yield put({type:commonConstants.showErrorMessage,payload:response.errorMessage})
        }
    } catch (error) {
        yield put({type:cookieConstants.getCookieFailure,payload:error.Message})
        yield put({type:commonConstants.showErrorMessage,message:error.message})
    }
}
function * updateCookiesSaga(action:any):any{
    try {
        const response = yield call(cookiesService.updateCookieService,action.payload);
        if(response.success){
            yield put({type:cookieConstants.updateCookieSuccess,payload:response.resultObject})
        }else{
            yield put({type:cookieConstants.updateCookieFailure,payload:response.errorMessage})
            yield put({type:commonConstants.showErrorMessage,payload:response.errorMessage})
        }
    } catch (error) {
        yield put({type:cookieConstants.updateCookieFailure,payload:error.Message})
        yield put({type:commonConstants.showErrorMessage,message:error.message})
    }
}

export const cookieSaga = {
    createCookiesSaga,
    getCookiesSaga,
    updateCookiesSaga
}